import { IntervalUnit, Interval, IFrequency, Group } from '../../models';
import { TimeUnit } from '../../models/enum';

export interface IIntervalService {
    getInterval(frequency: IFrequency): Interval;
    getFrequency(interval: Interval): IFrequency;
    getTimeUnit(unit: IntervalUnit): TimeUnit;
    getGroupInterval(group: Group, defaultFreq: IFrequency): Interval;
}

export class IntervalService implements IIntervalService {
    static serviceId: string = 'intervalService';

    getInterval(frequency: IFrequency): Interval {
        const interval = frequency.interval;
        let unit: IntervalUnit;
        
        // Same as momentHelper.getPrefix
        switch (frequency.intervalTimeUnit) {
            case TimeUnit.Second:
                unit = 's';
                break;
            case TimeUnit.Minute:
                unit = 'm';
                break;
            case TimeUnit.Hour:
                unit = 'h';
                break;
            case TimeUnit.Day:
                unit = 'd';
                break;
            case TimeUnit.Week:
                unit = 'w';
                break;
            case TimeUnit.Month:
                unit = 'M';
                break;
            case TimeUnit.Year:
                unit = 'y';
                break;
            default:
                unit = 'd';
                break;
        }
        const result: Interval = {
            interval: interval,
            unit: unit
        };
        return result;
    }


    getTimeUnit(unit: IntervalUnit): TimeUnit {
        let result: TimeUnit = TimeUnit.Day;
        switch (unit) {
            case 's':
                result = TimeUnit.Second;
                break;
            case 'm':
                result = TimeUnit.Minute;
                break;
            case 'h':
                result = TimeUnit.Hour;
                break;
            case 'd':
                result = TimeUnit.Day;
                break;
            case 'w':
                result = TimeUnit.Week;
                break;
            case 'M':
                result = TimeUnit.Month;
                break;
            case 'y':
                result = TimeUnit.Year;
                break;
        }
        return result;
    }

    getFrequency(interval: Interval): IFrequency {
        const freq: IFrequency = {
            interval: interval.interval,
            intervalTimeUnit: this.getTimeUnit(interval.unit)
        };
        return freq;
    }

    getGroupInterval(group: Group, defaultFreq: IFrequency): Interval {
        const freq = (group.frequency.interval > 0)
            ? group.frequency
            : defaultFreq;
        return this.getInterval(freq);
    }
}